
export const SET_LIVE_VIEW_DATA_STATUS = "SET_LIVE_VIEW_DATA_STATUS";
export const SET_LIVE_VIEW_DATA_DATA = 'SET_LIVE_VIEW_DATA_DATA';
export const CLEAR_LIVE_VIEW_SESSION_DATA = 'CLEAR_LIVE_VIEW_SESSION_DATA';